import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../containers/UseAuth';
import { newCampaignActions } from '../../../../store';
import SwitcherButton from '../../../Buttons/CommonSwitcher';
import { RequiredTag } from '../../../Input/RequiredTag';

const Naming = ({
    name,
    brand,
    dispatch,
    isTest,
    validator,
    onNameChange,
    onBrandChange,
}) => {
    const { t } = useTranslation();
    const auth = useAuth();

    return (
        <div className="module rounded m-1 -mb-0">
            <div className="header flex justify-between content-center">
                <div className="title text-xl font-extralight">
                    {t(
                        'sections.campaigns.new-campaign.wizard-basics.naming.title'
                    )}
                </div>
            </div>

            <div className="body rounded-sm mt-2">
                {(auth.isAdmin() || auth.isSupervising()) && (
                    <div className="w-28 ml-auto absolute right-4 -top-1 ">
                        <div className="realative">
                            <SwitcherButton
                                testId="WizardBasics-testing"
                                status={isTest}
                                onToggle={() =>
                                    dispatch(
                                        newCampaignActions.setIsTest(!isTest)
                                    )
                                }
                                labelOn={t(
                                    'sections.campaigns.new-campaign.wizard-basics.naming.testing'
                                )}
                                labelOff={t(
                                    'sections.campaigns.new-campaign.wizard-basics.naming.testing'
                                )}
                                hintTitle={t(
                                    'sections.campaigns.new-campaign.wizard-basics.naming.testing'
                                )}
                                hintMessage={t(
                                    'sections.campaigns.new-campaign.wizard-basics.naming.hintTesting'
                                )}
                                dataFor="testint-switcher-hint"
                            />
                        </div>
                    </div>
                )}
                <div className="flex flex-col md:flex-row md:space-x-4">
                    <label className="block lg:w-3/6 2xl:w-2/6">
                        <span className="block text-sm font-medium text-gray-700">
                            {t(
                                'sections.campaigns.new-campaign.wizard-basics.naming.campaignName-label'
                            )}{' '}
                            <RequiredTag alert={validator.errors.name} />
                        </span>
                        <input
                            type="text"
                            value={name}
                            name="campaign-name"
                            onChange={(e) => onNameChange(e.target.value)}
                            id="campaign-name"
                            className={`block w-full pr-12 sm:text-sm rounded-md mt-1 outline-none transition-colors ${validator.errors.name
                                    ? 'border-red-500 ring-1 ring-red-500 hover:border-red-500'
                                    : 'border-gray-300 focus:outline-none focus:ring-0 focus:outline-none hover:border-gray-400'
                                }`}
                            placeholder={t(
                                'sections.campaigns.new-campaign.wizard-basics.naming.campaignName-placeholder'
                            )}
                            onBlur={() => {
                                validator.touchField('name');
                                validator.validateField('name');
                            }}
                        />

                        {validator.shouldShowError('name') && (
                            <p className="mt-1 text-sm text-red-500">
                                {validator.errors.name}
                            </p>
                        )}
                    </label>
                    <label className="block lg:w-3/6 2xl:w-2/6 mb-4">
                        <span className="block text-sm font-medium text-gray-700">
                            {t(
                                'sections.campaigns.new-campaign.wizard-basics.naming.brand-label'
                            )}{' '}
                            <RequiredTag alert={validator.errors.brand} />
                        </span>
                        <input
                            type="text"
                            value={brand}
                            name="campaign-brand"
                            onChange={(e) => onBrandChange(e.target.value)}
                            id="campaign-brand"
                            className={`block w-full pr-12 sm:text-sm rounded-md mt-1 outline-none transition-colors ${validator.errors.brand
                                    ? 'border-red-500 ring-1 ring-red-500 hover:border-red-500'
                                    : 'border-gray-300 focus:outline-none focus:ring-0 focus:outline-none hover:border-gray-400'
                                }`}
                            placeholder={t(
                                'sections.campaigns.new-campaign.wizard-basics.naming.brand-placeholder'
                            )}
                            onBlur={() => {
                                validator.touchField('brand');
                                validator.validateField('brand');
                            }}
                        />
                        {validator.shouldShowError('brand') && (
                            <p className="mt-1 text-sm text-red-500">
                                {validator.errors.brand}
                            </p>
                        )}
                    </label>
                </div>
            </div>
        </div>
    );
};

export default Naming;
